import api from "./api";

// Capa de servicios API del dominio "integraciones de cola" (queueIntegration) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listQueueIntegrations = (params) =>
  api.get("/queueIntegration", { params });
export const getQueueIntegration = (integrationId) =>
  api.get(`/queueIntegration/${integrationId}`);
export const createQueueIntegration = (payload) =>
  api.post("/queueIntegration", payload);
export const updateQueueIntegration = (integrationId, payload) =>
  api.put(`/queueIntegration/${integrationId}`, payload);
export const deleteQueueIntegration = (integrationId) =>
  api.delete(`/queueIntegration/${integrationId}`);
export const testQueueIntegrationSession = (payload) =>
  api.post("/queueIntegration/testSession", payload);
